export default {
  filter: {
    timeBucket: 'Granularność',
  },
  stackedPolarChart: {
    title: 'Produktywność (Polar)',
  },
  clusteredStackedBarChart: {
    title: 'Produktywność (słupek klastrowany)',
    hint: 'Z powodu filtra czasowego ten przedział czasowy jest reprezentowany tylko częściowo. Najedź kursorem na wykres, aby uzyskać więcej szczegółów.',
  },
  table: {
    title: 'Produktywność (Tabela)',
  },
  stackedBarChart: {
    title: 'Produktywność (pasek skumulowany)',
  },
  paretoChart: {
    title: 'Produktywność (Pareto)',
  },
  visualisationModal: {
    title: 'Ustawienia wyświetlania',
    subtitle: 'Z poniższych list wybierz wykresy, które chcesz wyświetlić na pulpicie.',
    aggregationTitle: 'Zbiór',
    aggregationDescription: 'Te wykresy pokazują wydajność dla całego wybranego przedziału czasu',
  },
};
